"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ramda_1 = require("ramda");
exports.getEmail = ramda_1.pathOr(null, ["state", "email"]);
//# sourceMappingURL=get-email.js.map